import { createPortal } from 'react-dom';
import { mediaById } from '../data/graph';
import type { GraphNode } from '../data/types';
import { dateLabel } from '../lib/selectors';

export interface HoverTarget {
  nodeId: string;
  x: number;
  y: number;
}

const typeLabels: Record<GraphNode['type'], string> = {
  company: 'przedsiębiorstwo', person: 'osoba', architecture: 'architektura', place: 'miejsce', machine: 'maszyna', technology: 'technologia', process: 'proces', textile: 'tkanina / produkt', document: 'dokument', photograph: 'fotografia', map: 'mapa', event: 'wydarzenie', trade: 'handel', heritage: 'dziedzictwo',
};

export function NodeHoverCard({ node, target }: { node?: GraphNode; target?: HoverTarget }): JSX.Element | null {
  if (!node || !target) return null;
  const media = node.mediaIds?.map((id) => mediaById.get(id)).find((asset) => asset?.localPath);
  const cardWidth = 258;
  const cardHeight = media ? 190 : 104;
  const left = Math.max(12, Math.min(target.x + 17, window.innerWidth - cardWidth - 12));
  const top = Math.max(12, Math.min(target.y + 17, window.innerHeight - cardHeight - 12));

  return createPortal(<aside className="node-hover-card" style={{ left, top }} aria-label={`Podgląd: ${node.title}`}>
    {media?.localPath && <img src={media.localPath} alt="" />}
    <div><span className="eyebrow">{typeLabels[node.type]}</span><strong>{node.title}</strong><small>{dateLabel(node)} · {node.confidence === 'high' ? 'wysoka' : node.confidence === 'medium' ? 'średnia' : 'niska'} pewność</small></div>
  </aside>, document.body);
}

